import React, { useState } from "react";
import Layout, { Container } from "../components/layout";
import { CheckCircle, AlertTriangle, XCircle, Info } from "lucide-react";

const notifications = [
  {
    id: 1,
    type: "info",
    message: "🎉 New HR policy announced.",
    date: "2025-06-17",
    url: "https://company.com/hr-policy",
  },
  {
    id: 2,
    type: "warning",
    message: "⚠ Your leave request is still under review.",
    date: "2025-06-15",
  },
  {
    id: 3,
    type: "error",
    message: "❌ You missed your attendance on 2025-06-14.",
    date: "2025-06-14",
    actionButtons: [
      { label: "Mark Present", action: "mark-attendance" },
      { label: "Notify HR", action: "notify-hr" },
    ],
  },
  {
    id: 4,
    type: "action",
    message: "📝 Leave request from John Doe (20-22 June)",
    date: "2025-06-16",
    actionButtons: [
      { label: "Approve", action: "approve-leave" },
      { label: "Reject", action: "reject-leave" },
    ],
    metadata: { leaveId: "123abc" },
  },
];

const getNotificationStyle = (type) => {
  switch (type) {
    case "info":
      return { color: "text-blue-800", bg: "bg-blue-100", Icon: Info };
    case "warning":
      return { color: "text-yellow-800", bg: "bg-yellow-100", Icon: AlertTriangle };
    case "error":
      return { color: "text-red-800", bg: "bg-red-100", Icon: XCircle };
    case "action":
      return { color: "text-indigo-800", bg: "bg-indigo-100", Icon: CheckCircle };
    default:
      return { color: "text-gray-800", bg: "bg-gray-100", Icon: Info };
  }
};

export default function Notifications() {
  const handleNotificationAction = (action, metadata) => {
    console.log("Action Triggered:", action, metadata);
    // You can route this to an API call or modal confirmation
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-4 bg-[#f5f7fb] min-h-screen space-y-6">
          <h1 className="text-2xl font-semibold text-gray-800 mb-4">🔔 Notifications</h1>

          <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-xl font-semibold mb-4">Your Notifications</h2>
            <ul className="space-y-4">
              {notifications.map((n) => {
                const { color, bg, Icon } = getNotificationStyle(n.type);
                return (
                  <li key={n.id} className={`flex flex-col md:flex-row items-start md:items-center justify-between p-4 rounded-xl ${bg} ${color}`}>
                    <div className="flex items-start gap-3">
                      <Icon className="w-6 h-6 mt-1" />
                      <div>
                        <p className="font-medium">{n.message}</p>
                        <p className="text-sm text-gray-600">{n.date}</p>
                        {n.url && (
                          <a
                            href={n.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline text-sm mt-1 inline-block"
                          >
                            View Details
                          </a>
                        )}
                      </div>
                    </div>

                    {n.actionButtons && (
                      <div className="mt-3 md:mt-0 flex gap-2">
                        {n.actionButtons.map((btn) => (
                          <button
                            key={btn.label}
                            onClick={() => handleNotificationAction(btn.action, n.metadata)}
                            className="px-3 py-1 rounded bg-indigo-600 text-white hover:bg-indigo-700 text-sm"
                          >
                            {btn.label}
                          </button>
                        ))}
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Container>
    </Layout>
  );
}